const baseUrl = location.protocol + '//' + location.host + '/';

export default baseUrl;